app.service("CacheSettingsService", ['$rootScope', function ($rootScope) {

    const service = this;

    const cacheVersion = 1;

    const CacheSettingsModel = function () {
        this.settings = {};
    };

    this.model = new CacheSettingsModel();
    const model = this.model;

    function retrieveSettings() {
        const cacheSettingsSettingsName = 'cache_settings_settings';
        const json = localStorage.getItem(cacheSettingsSettingsName);
        let settings = json ? JSON.parse(json) : null;
        settings = settings && settings.cache_version === cacheVersion ? settings : {
            cache_version: cacheVersion
        };
        model.settings = settings;
        validateSettings();
    }

    function validateSettings() {
        let valid = true;
        if (model.settings.dev_mode) {
            if (!$rootScope.service.account.isDevModeAvailable()) {
                delete model.settings.dev_mode;
                valid = false;
            }
        }
        if (!valid) {
            service.saveSettings();
        }

    }

    this.saveSettings = function () {
        const cacheSettingsSettingsName = 'cache_settings_settings';
        const json = JSON.stringify(model.settings)
        localStorage.setItem(cacheSettingsSettingsName, json);
    }

    this.applySetting = function (id, value) {
        if (value) {
            model.settings[id] = value;
        } else {
            delete model.settings[id];
        }
        service.saveSettings();
    }

    $rootScope.$on('customer_data_replaced', function ($event, params) {
        retrieveSettings();
    });

}]);